import { jsxs as l, Fragment as B, jsx as i } from "react/jsx-runtime";
import { forwardRef as D, useRef as p, useMemo as F, useState as G, useLayoutEffect as H } from "react";
import { ChipGroup as y } from "./index.es35.js";
import d from "classnames";
import t from "./index.es5617.js";
import { useChipOverflow as M } from "./index.es5618.js";
import { BaseSelectBox as E } from "./index.es834.js";
import { Link as T } from "./index.es68.js";
const O = "chip-selector-component", Q = D(
  ({
    value: e,
    testId: r = O,
    maxChipRows: z = 3,
    disabled: m,
    size: L = "default",
    LeftIcon: a,
    colorIndicator: f,
    entityColor: g,
    isOpen: s,
    ...j
  }, k) => {
    var R, S;
    const u = d(t.triggerContainer, {
      [t.hasChips]: e == null ? void 0 : e.length,
      [t.hasLeftIcon]: a || f || g
    }), C = d(t.valueContainer, {
      [t.disabled]: m
    }), x = p(null), n = p(null), P = p(null), { sizingObject: c, showMore: h } = M(
      e,
      z,
      x
    ), o = !!(e != null && e.length), _ = F(
      () => o ? [...e].splice(0, c.index) : [],
      [o, c.index, e]
    ), [N, b] = G(!1);
    return H(() => {
      N && !s && setTimeout(() => {
        var w;
        (w = n.current) == null || w.focus();
      }, 40), b(!s);
    }, [s, N]), /* @__PURE__ */ l(B, { children: [
      /* @__PURE__ */ i(
        "div",
        {
          className: d(u, t.calculationComponent),
          style: {
            width: (R = n.current) == null ? void 0 : R.clientWidth,
            height: (S = n.current) == null ? void 0 : S.clientHeight
          },
          children: /* @__PURE__ */ i(
            E,
            {
              value: o ? /* @__PURE__ */ i("div", { className: C, ref: x, children: /* @__PURE__ */ i(y, { size: "small", chips: e, children: h && /* @__PURE__ */ i("div", { children: /* @__PURE__ */ l(T, { children: [
                e.length - Number(c.index),
                " more"
              ] }) }) }) }) : void 0,
              testId: r + "-fake-component"
            }
          )
        }
      ),
      /* @__PURE__ */ i(
        "div",
        {
          className: u,
          "data-testid": r ? r + "-container" : "chip-selector-select-container",
          ref: k,
          children: /* @__PURE__ */ i(
            E,
            {
              testId: r,
              ref: n,
              disabled: m,
              size: o ? "default" : L,
              "data-has-chips": o,
              "data-has-more": h,
              LeftIcon: a,
              colorIndicator: f,
              isOpen: s,
              entityColor: g,
              value: e != null && e.length ? /* @__PURE__ */ i("div", { className: C, children: /* @__PURE__ */ i(
                y,
                {
                  size: "small",
                  chips: h ? _ : e,
                  testId: r ? `${r}-chip-group` : "chip-selector-chip-group",
                  ref: P,
                  children: h && /* @__PURE__ */ i("div", { children: /* @__PURE__ */ l(T, { disabled: m, children: [
                    e.length - Number(c.index),
                    " more"
                  ] }) })
                }
              ) }) : void 0,
              ...j
            }
          )
        }
      )
    ] });
  }
);
export {
  O as CHIP_SELECTOR_DEFAULT_TESTID,
  Q as ChipSelectorSelect
};
//# sourceMappingURL=index.es856.js.map
